var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpLogoDarkblueBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b9fd9a9a-a874-4237-858d-efbf0e26c2ce",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2918.74 245.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 2918.74,
    height: 245.09,
    style: {
      fill: "#21325b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.57,69.05a37.11,37.11,0,0,0-37.16,37.06v0a30.45,30.45,0,0,0,.2,4.25,79.21,79.21,0,0,0,6,22.25,88.06,88.06,0,0,0,4,8.89h0a33.5,33.5,0,0,1,53.86,0h0c1.42-2.92,2.8-5.89,4-8.89a79.52,79.52,0,0,0,6-22.25c0-1.43.2-2.85.2-4.25A37.12,37.12,0,0,0,1123.57,69.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.29,80.61h34.82c16.31,0,27.34,12,27.34,28.86s-11,29.08-27.34,29.08H960.82v25.91H940.29ZM970.89,121c7.17,0,10.68-4.91,10.68-11.49S978.06,98.2,971.23,98.2H960.82V121Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.06,80.61h29.2c8.57,0,12.68.59,16.31,2C1069.08,86.24,1075,94.88,1075,107c0,8.91-4.22,18.66-12.55,22.89v.22a45.08,45.08,0,0,1,3.17,5.06l16.41,29.3h-23l-14.9-28.25h-9.61v28.25h-20.53Zm29.47,38c6.56,0,10.66-3.64,10.66-10.32,0-4.22-1-7.37-4.91-8.91a19.12,19.12,0,0,0-7.71-1.18h-7v20.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172,80.61h34.83c16.31,0,27.31,12,27.31,28.86s-11,29.08-27.31,29.08h-14.22v25.91H1172Zm30.6,40.35c7.15,0,10.69-4.91,10.69-11.49s-3.54-11.27-10.34-11.27h-10.34V121Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.72,80.61h52.46V98.2h-31.93v15.25h25.59V131h-25.59v15.84h33.65v17.59h-54.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310,80.61h29.2c8.55,0,12.65.59,16.31,2C1365,86.24,1371,94.88,1371,107c0,8.91-4.23,18.66-12.55,22.89v.22a51.71,51.71,0,0,1,3.17,5.06l16.28,29.3H1355l-14.88-28.25h-9.62v28.25H1310Zm29.47,38c6.56,0,10.66-3.64,10.66-10.32,0-4.22-1-7.37-4.91-8.91a19.26,19.26,0,0,0-7.74-1.18h-6.93v20.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1407.76,98.2h-25.44V80.61h71.41V98.2h-25.39v66.31h-20.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1487.28,130.1l-27.75-49.49h23.35l9.51,20.17c2.68,5.74,4.91,12.08,4.91,12.08h.25s2.45-6.34,5-12.08L1512,80.61h23.33l-27.55,49.49v34.38h-20.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547,80.61h34.85c16.28,0,27.33,12,27.33,28.86s-11,29.08-27.33,29.08h-14.32v25.91H1547ZM1577.66,121c7.14,0,10.65-4.91,10.65-11.49S1584.8,98.2,1578,98.2h-10.44V121Z",
    style: {
      fill: "#b5e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.81,80.61h52.55V98.2h-31.93v15.25H1667V131h-25.66v15.84H1675v17.59h-54.2Z",
    style: {
      fill: "#b5e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.69,79.19c26,0,43.86,18.79,43.86,42.83,0,24.56-17.83,43.86-43.86,43.86s-43.86-19.23-43.86-43.86C1684.83,98,1702.63,79.19,1728.69,79.19Zm0,67.93c13.26,0,22.64-10.81,22.64-25.1,0-13.73-9.38-24-22.64-24s-22.64,10.31-22.64,24C1706.05,136.31,1715.43,147.12,1728.69,147.12Z",
    style: {
      fill: "#b5e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.14,80.61H1819c16.31,0,27.34,12,27.34,28.86s-11,29.08-27.34,29.08H1804.7v25.91h-20.56ZM1814.77,121c7.17,0,10.68-4.91,10.68-11.49s-3.51-11.27-10.34-11.27H1804.7V121Z",
    style: {
      fill: "#b5e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1857.94,80.61h20.53v66.31h34.24v17.59h-54.77Z",
    style: {
      fill: "#b5e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1924.42,80.61H1977V98.2H1945v15.25h25.56V131h-25.76v15.84h33.62v17.59h-54Z",
    style: {
      fill: "#b5e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.57,92.67a15.11,15.11,0,1,0,10.66,4.42A15.11,15.11,0,0,0,1123.57,92.67Z",
    style: {
      fill: "#b5e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1150.49,141.52a33.48,33.48,0,0,0-53.86,0h0A218.25,218.25,0,0,0,1115,171.58h0a10.53,10.53,0,0,0,17.19,0h0a221.32,221.32,0,0,0,18.35-30.06Z",
    style: {
      fill: "#b5e1fa"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpLogoDarkblueBg);
export default __webpack_public_path__ + "static/media/pp-logo-darkblue-bg.897f8630.svg";
export { ForwardRef as ReactComponent };